import { useState } from "react";

export const useValidation = (initialState, validations) => {
    const [errors, setErrors] = useState({});

    const validate = (field, value) => {
        const rules = validations[field];
        if (!rules) return;

        const error = rules
            .map((rule) => rule(value))
            .filter((msg) => msg !== null)[0];
        setErrors((prev) => ({ ...prev, [field]: error || "" }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        validate(name, value);
    };

    const validateForm = (formData) => {
        const newErrors = {};
        Object.keys(validations).forEach((field) => {
            const value = formData[field];
            const rules = validations[field];
            const error = rules
                .map((rule) => rule(value))
                .filter((msg) => msg !== null)[0];
            if (error) newErrors[field] = error;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return { errors, handleChange, validateForm };
};
